import { Theme } from '@mui/material';

export const getVizTooltipStyles = (theme: Theme) => ({
  contentStyle: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadiusMd,
    padding: theme.spacing(0.75, 1),
    boxShadow: theme.shadows[8],
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body2.fontSize,
  },
  labelStyle: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.micro1.fontSize,
  },
  itemStyle: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.body2.fontSize,
  },
});
export const VIZ_EXPANDED = '@container (min-width: 480px)';
